module.exports = __webpack_public_path__ + "static/img/helh24.7cbbd85.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/healthycockpit/helh24.png
// module id = MoRq
// module chunks = 5